export const MISSION_PLANNER_KEYS = {
  main: 'mission-planner',
  plans: 'plans',
  surgeons: 'surgeons',
  commercialFlights: 'commercial-flights',
  benchmark: 'benchmark',
};

export const missionPlannerQueryKeys = {
  getBenchmark: (...args: unknown[]) => [MISSION_PLANNER_KEYS.main, MISSION_PLANNER_KEYS.benchmark, ...args],
  getPlans: (...args: unknown[]) => [MISSION_PLANNER_KEYS.main, MISSION_PLANNER_KEYS.plans, ...args],
  getSurgeonPlans: (...args: unknown[]) => [
    ...missionPlannerQueryKeys.getPlans(),
    MISSION_PLANNER_KEYS.surgeons,
    ...args,
  ],
  getCommercialPlans: (...args: unknown[]) => [
    ...missionPlannerQueryKeys.getPlans(),
    MISSION_PLANNER_KEYS.commercialFlights,
    ...args,
  ],
};
